import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SvgIcons from '../../internals/svg';

// Recolor every shape element, not just <path>. Webpack's svgo-loader ran `convertShapeToPath`,
// so under webpack all icons reached this CSS as <path> and were recolored; Vite's pipeline keeps
// the original tags (<rect>/<circle>/<line>/<polygon>/<polyline>/<ellipse>), so the selectors must
// cover them too — otherwise those shapes keep their raw fill/stroke and render black.
const SHAPES = ['path', 'rect', 'circle', 'ellipse', 'line', 'polygon', 'polyline'];
const shapeSel = attr => SHAPES.map(shape => `${shape}${attr}`).join(',\n    ');

const Wrap = styled.svg`
    ${shapeSel(':not([stroke])')},
    ${shapeSel("[stoke='none']")} {
        stroke: none !important;
    }

    ${shapeSel('[stroke]')} {
        stroke: ${props => props.color};
    }

    ${shapeSel(':not([fill])')},
    ${shapeSel("[fill='none']")} {
        fill: none !important;
    }

    ${shapeSel('[fill]')} {
        fill: ${props => props.color};
    }
`;

class Svg extends React.Component {
    static propTypes = {
        color: PropTypes.string
    };

    static defaultProps = {
        color: ''
    };

    render() {
        const { props } = this;
        const { type, ...restProps } = props;

        let icon = SvgIcons[type];

        if (!icon) {
            return (
                <Wrap className="cla-svg" viewBox="0 0 16 16" {...restProps} />
            );
        }

        icon = icon().props.children;
        return (
            <Wrap className="cla-svg" viewBox="0 0 16 16" {...restProps}>
                {icon}
            </Wrap>
        );
    }
}

export default Svg;
